import SectionHeading from '@/components/feature/SectionHeading';
import ProductCard from '@/components/feature/ProductCard';
import { getCategoryById, getFeaturedProducts } from '@/pages/products/productUtils';

export default function FeaturedProducts() {
  const featured = getFeaturedProducts();

  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="Most Loved"
          title="Our Best Selling Medicines"
          description="The formulations our distributors and customers reorder again and again."
        />

        <div
          data-product-shop="true"
          className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5"
        >
          {featured.map((product) => {
            const category = getCategoryById(product.category);
            return (
              <ProductCard key={product.id} product={product} categoryLabel={category ? category.name : 'Ayurvedic'} />
            );
          })}
        </div>
      </div>
    </section>
  );
}